import { AuthCompleteEmailVerificationEndAction } from "../actions/AuthCompleteEmailVerification";
import { AuthState } from "../state";
import { setProfile, setStoredCredentials } from "../util";

export function completeEmailVerification(state: AuthState, action: AuthCompleteEmailVerificationEndAction) {
    const { error } = action.payload;
    if (!error) {
        if (state.profile) { // No idea when this would be false, but being extra defensive.
            const profile = {...state.profile};
            profile.emailVerified = true;
            setStoredCredentials(state.credentials);
            setProfile(profile);
            return { ...state, profile };
        }
    }
    return state;
}